import { Listbox } from '@headlessui/react';
import { isSkillup, isWhereWeGo } from '../../../lib/config/project/project';
import { Sort } from '../../../lib/types';
import Selector from '../../icons/Selector';

interface MobileSortProps {
  selectedSort: Sort | undefined;
  applySort: (option: Sort) => void;
  sortOptions: Sort[];
  isCareers?: boolean;
}

const MobileSort: React.FC<MobileSortProps> = ({
  selectedSort,
  applySort,
  sortOptions,
  isCareers,
}) => {
  const textClass =
    isSkillup || (isWhereWeGo && !isCareers)
      ? 'text-primary'
      : 'text-careerPageHeading';
  return (
    <div className="z-10 p-4">
      <Listbox value={selectedSort} onChange={applySort}>
        <Listbox.Button className="w-full">
          <div className="flex items-center justify-between w-full">
            <p className="text-base font-bold text-gray2">
              {selectedSort?.label}
            </p>
            <Selector className="h-9 w-9 stroke-gray8 stroke-width-2" />
          </div>
        </Listbox.Button>
        <Listbox.Options className="p-2 bg-white border-solid rounded-md border-1 border-gray8">
          {sortOptions.map((option) => (
            <Listbox.Option key={option.value} value={option}>
              {({ selected }) => {
                return (
                  <p
                    className={`${selected && `${textClass} font-bold `} my-2`}
                  >
                    {option.label}
                  </p>
                );
              }}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  );
};

export default MobileSort;
